import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { mutate } from 'swr';
import { useGetCartData } from '../../../datafetchers/CartWidget';
import { addGoToCartEvent } from '../../../Utils/CategoryPageUtils';
import { addToCartHandler, getCartButton } from '../../../Utils/productAction';
import { navigateToCartPage } from '../../../Utils/redirections';
import { CssLoader } from '../../StoreHomePage/AddToCartButton/styled';
import { AddToCartButtonFilled, OutOfStock } from './styled';

export default function AddToCartCta(props) {
  const {
    section,
    product,
    category_name,
    setAddedToCart,
    parentTag,
    aplusplus,
    smallButton,
    isCategoryPage,
    statusOfIds,
    newUI,
    singleProduct,
  } = props;
  const { data } = useGetCartData();
  const productId = product?._id || product?.id;
  const [inCart, setInCart] = useState(false);
  const [isOutOfStock, setIsOutOfStock] = useState();
  const [loaderState, setLoaderState] = useState('');
  const [clickEffect, setClickEffect] = useState('');
  const router = useRouter();
  useEffect(() => {
    if (getCartButton(parseInt(productId)) === 2) {
      setInCart(true);
    } else {
      setLoaderState('');
      setInCart(false);
    }
  }, [router.query]);

  useEffect(() => {
    const statusOfId = statusOfIds?.filter((ele) => ele.id == productId);
    if (statusOfIds?.length && statusOfId?.[0]?.status === '4') {
      setIsOutOfStock(true);
    }
  }, [statusOfIds]);

  const ctaClickHandler = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (inCart) {
      addGoToCartEvent(
        'clicked_go_to_cart',
        section,
        product,
        category_name,
        parentTag,
      );
      setClickEffect('lowOpacity');
      setTimeout(() => {
        navigateToCartPage();
        setClickEffect('');
      }, 100);
    } else {
      if (data) {
        await mutate('/api/getNewCartAmountOfUserWeb', null, false);
      }
      setLoaderState('loading');
      addGoToCartEvent(
        'clicked_add_to_cart',
        section,
        product,
        category_name,
        parentTag,
      );
      const success = await addToCartHandler(productId);
      if (success == true) {
        setLoaderState('loaded');
        setTimeout(() => {
          setInCart(true);
        }, 800);
      } else {
        setInCart(false);
      }
    }
    if (setAddedToCart) setAddedToCart((props) => !props);
  };
  return (
    <>
      {isOutOfStock ? (
        <OutOfStock>OUT OF STOCK</OutOfStock>
      ) : (
        <AddToCartButtonFilled
          verm={inCart}
          className={`add_btn_filled ${clickEffect} ${
            singleProduct ? 'newView' : ''
          }`}
          onClick={ctaClickHandler}
          smallButton={smallButton}
          newUI={newUI}
        >
          {inCart ? (
            'GO TO CART'
          ) : loaderState === 'loading' || loaderState === 'loaded' ? (
            <CssLoader
              borderColor={'#fff'}
              className={loaderState === 'loaded' ? 'load-complete' : ''}
              isCategoryPage={isCategoryPage}
              newUI={newUI}
              //aplusplus={aplusplus}
            >
              <div
                className="checkmark draw"
                style={loaderState === 'loaded' ? { display: 'block' } : {}}
              ></div>
            </CssLoader>
          ) : (
            'ADD TO CART'
          )}
        </AddToCartButtonFilled>
      )}
    </>
  );
}
